import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
//import { LabelMarginType } from "echarts/types/src/label/labelStyle.js";

interface BomItem {
  name: string;
  quantity?: number;
}

interface BomChartProps {
  data: BomItem[];
  type?: 'RawMaterial' | 'PackagingMaterial';
}

const BomChart: React.FC<BomChartProps> = ({ data, type }) => {
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!chartRef.current) return;
    const chartInstance = echarts.init(chartRef.current);

    // 根据 type 计算 total
    const total =
      type === 'PackagingMaterial'
        ? data.reduce((sum, item) => sum + Number(item.quantity || 0), 0)
        : data.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const totalDisplay =
      type === 'PackagingMaterial'
        ? `Total: ${total.toFixed(1)}(kg)`
        : `Total: ${total.toFixed(1)}(kg)`;

    const option = {

      tooltip: {
        trigger: "item",
        formatter: params =>
          type === 'PackagingMaterial'
            ? `${params.name}: ${params.value}`
            : `${params.name}: ${params.percent}%`
      },
      graphic: [
        {
          type: 'text',
          left: 'center',
          bottom: 1,
          style: {
            text:
              type === 'PackagingMaterial'
                ? `${totalDisplay}`
                : `${totalDisplay}`,
            fill: '#333',
            fontSize: 12,
            marginLeft: 20,
            paddingLeft: 10,
          }
        },
      ],
      legend: {
        orient: "vertical",
        left: "left",
      },
      series: [
        {
          name: type === 'PackagingMaterial' ? "包装材料" : "配料",
          type: "pie",
          radius: "50%",
          data: data.map(item => ({
            name: item.name,
            value: type === 'PackagingMaterial' ? item.quantity : item.quantity
          })),
          label: {
            show: false,
            position: "right",
            formatter: (params) => params.name.length > 35 ? params.name.slice(0, 35) + '…' : params.name
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }
      ]
    };

    chartInstance.setOption(option);

    return () => {
      chartInstance.dispose();
    };
  }, [data, type]);

  return <div ref={chartRef} style={{ width: "100%", height: 400, paddingBottom: '20px' }} />;
};

export default BomChart;
